import React, { useState } from 'react';
import { XIcon, RocketIcon } from 'lucide-react';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-gray-900 text-white px-4 py-3 relative flex items-center justify-center z-50" data-id="element-11">
      <div className="flex items-center space-x-2 text-sm md:text-base font-medium" data-id="element-12">
        <RocketIcon className="h-4 w-4 text-red-500" data-id="element-13" />
        <span data-id="element-14">Free 60-Minute Strategy Session — Book Now</span>
      </div>
      <button onClick={() => setIsVisible(false)} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors" aria-label="Close announcement" data-id="element-15">
        <XIcon className="h-5 w-5" data-id="element-16" />
      </button>
    </div>;
}